import styled from "@emotion/styled";
import { compact } from "lodash";
import * as React from "react";

import { DesignToken, Text } from "@livechat/design-system-react-components";

import { IAgent } from "store/entities/agents";
import { ITeam } from "store/entities/teams";
import { withVar } from "themes/helpers";

interface IProps {
  agent?: IAgent;
  team: ITeam;
  hideDefaultInfo?: boolean;
}

export const AssignmentInfo: React.FC<IProps> = ({ agent, team, hideDefaultInfo = false }) => {
  const summary = compact([team?.name, agent?.name]).join(" / ");

  return (
    <SummaryText customColor={withVar(DesignToken.ContentBasicSecondary)}>
      {summary} {!hideDefaultInfo && team?.isDefault && <>(Default team)</>}
    </SummaryText>
  );
};

const SummaryText = styled(Text)`
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: bottom;
`;
